import { logError } from "@/lib/errorLogger";

let installed = false;

export function installGlobalErrorHandlers(): void {
  if (installed) return;
  installed = true;

  // Uncaught exceptions
  window.addEventListener("error", (event) => {
    logError({
      message: event.message || "Unknown error",
      stack: event.error?.stack,
      source: "frontend",
      severity: "error",
      metadata: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  });

  // Unhandled promise rejections
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    logError({
      message: reason?.message || String(reason) || "Unhandled promise rejection",
      stack: reason?.stack,
      source: "frontend",
      severity: "error",
      metadata: { type: "unhandledrejection" },
    });
  });
}
